import { format } from "date-fns";

export const transformFileData = (arr) => {
  const header = arr[0];
  const result = [];
  for (let i = 1; i < arr.length; i++) {
    const o = { id: i };
    header.forEach((el, hi) => {
      o[el] = arr[i][hi];
    });
    result.push(o);
  }
  return result;
};

export const formatISODate = (date) => format(new Date(date), "yyyy-MM-dd");
